import { Box, Button, Paper, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

/** Shown instead of a POS menu page when the menu map couldn't be loaded. */
const MenuLoadError = ({ onRetry, onBack, backLabel }) => (
  <Box sx={{ p: 3 }}>
    {onBack && (
      <Button
        variant="text"
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        sx={{ mb: 2 }}
      >
        {backLabel}
      </Button>
    )}
    <Paper sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        Couldn&apos;t load the menu
      </Typography>
      <Typography color="textSecondary" sx={{ mb: 3 }}>
        Check your connection and try again.
      </Typography>
      <Button variant="contained" onClick={onRetry}>
        Try again
      </Button>
    </Paper>
  </Box>
);

export default MenuLoadError;
